/**
 * @requires ../../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/base.js
 * @requires ../../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/quiz.js
 */

var init_dutyofcare = function(config) {
	/* Init stepWizard */
	wizard = new nnip.classes.StepWizard('.step-indicator-v2', config);
	if (typeof docMustacheButtonTemplateId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheButtonTemplateId, docButtonTemplate);
	
	if (typeof docMustacheAccountTemplateId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheAccountTemplateId, docAccountTemplate);

	if (typeof docMustacheMultipleAccountTemplateId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheMultipleAccountTemplateId, docMultipleAccountTemplate);

	if (typeof docMustacheInvestmentMethodId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheInvestmentMethodId, docInvestmentMethodTemplate);
	if (typeof docMustacheInvestmentProfileId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheInvestmentProfileId, docInvestmentProfileTemplate);
	if (typeof docMustacheInvestmentPortfolioId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheInvestmentPortfolioId, docInvestmentPortfolioTemplate);
	if (typeof docMustacheSummaryId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheSummaryId, docSummaryTemplate);
	if (typeof docMustacheConfirmationId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheConfirmationId, docConfirmationTemplate);
	if (typeof docMustacheAssetPartialId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheAssetPartialId, docAssetPartial);
	if (typeof docMustacheQuestionaireId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheQuestionaireId, docQuestionaireTemplate);
	if (typeof docMustachePortfolioDeviationId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustachePortfolioDeviationId, docPortfolioDeviationTemplate);
	if (typeof docMustacheOrderProposalId !== "undefined")
		wizard.getTemplates(docMustacheTemplate, docMustacheOrderProposalId, docOrderProposalTemplate);

	//retain portfolio
    if (typeof rpMustacheIntroId !== "undefined")
        wizard.getTemplates(rpMustacheTemplate, rpMustacheIntroId, rpIntroTemplate);
    if (typeof rpMustacheProfileId !== "undefined")
        wizard.getTemplates(rpMustacheTemplate, rpMustacheProfileId, rpProfileTemplate);

	getInvestmentAccounts();
    
     
	//disable Click event for links except navigation
	// Editted for Retain Portfolio
     $("a:not(#exitFlowModalTarget, .doc a, .close, .button--close)").on('click', function(e) {
         if(!(wizard.getActiveStep() === 1) && !(wizard.getActiveStep() === wizard.getStepWizard().total)) {
             var selectedLink = $(this).attr('href');
             $('#exitFlowModal').modal('show');
             $('#exitFlowModalTarget').attr('href', selectedLink);
             e.preventDefault;
             return false;           
         }
    });

    
	$('#docModal').on('hidden', function(event) {

		if ($('#docModal').data('type') === 'YOUTUBEVIDEO') {
			stopVideo();
		}

		// Cleanup modal
		$('#docModal #docModalLabel').html('');
		$('#docModal .modal-body').html('');

	});

	$('#quizModal').on('hidden', function(event) {
		$('#restartQuestionButton').trigger("click");
	});

	$('span[data-toggle="tab"]').on('shown', function(e) {
		clearError();
		var step = $(e.target).data('step');

		wizard.updateStep(step);
        $('#next').attr('disabled','disabled');
		var accountNumber = globalStore.selectedAccountNumber;
        var accountNumbers = globalStore.multipleSelectedAccountNumber;
        
        if(typeof(accountNumbers) !== 'undefined' && accountNumbers.length > 1){
            $('.multipleAccounts').show();
            $('.singleAccount').hide();
        }else {
            $('.singleAccount').show();
            $('.multipleAccounts').hide();
            $(".account_placeholder").html(' ' + accountNumber);  
        }
        

		var stepId = wizard.getActiveStepId();
        
		// select account
		if (stepId === "chooseaccount") {
			wizard.validateStep(step);
		}

		// Introduction
		if (stepId === "introduction") {
			getProductSwitchContextForAccount(accountNumber, step);
			wizard.validateStep(step);
		}

		// Investment method
		if (stepId === "investmentmethod") {
			var productSwitchContext = globalStore.productSwitchContext;
			dispayInvestmentMethods(productSwitchContext);
			wizard.validateStep(step);
		}

		// Risk Profile
		if (stepId === "riskprofile") {
			var riskProfileData = {};
            
            if(flowConfig.type === 'profile'){                
                docObject = new nnip.classes.DutyOfCare();
                if (globalStore.multipleSelectedAccountNumber && globalStore.multipleSelectedAccountNumber.length > 1 ){  
                    riskProfileData.originalRiskProfiles = globalStore.multipleSelectedProfiles;
                    riskProfileData.selectedAccountNumbers = globalStore.multipleSelectedAccountNumber;
                } else {
                    riskProfileData.selectedAccountNumber = globalStore.selectedAccountNumber;
                    riskProfileData.originalRiskProfile = globalStore.originalRiskProfile;
                    riskProfileData.originalRiskProfileLabel = jsLanguageLabel['txtInvestmentProfile_' + riskProfileData.originalRiskProfile];
				}             

				// skip RP steps in case selected account is not eligible for RP, but the at least one other account is.
				if( shouldSkipDoorbeleggenForAccount(globalStore.selectedAccountNumber) ){
					wizard.skipSteps([3,4]);
				} else {
					wizard.skipSteps([]);					
				}

                wizard.validateStep(step);
                getRiskProfile(accountNumbers, riskProfileData, step);
            }else{
				riskProfileData.originalRiskProfile = globalStore.productSwitchContext.riskProfileStatus.activeRiskProfile;
                riskProfileData.proposedRiskProfile = globalStore.productSwitchContext.riskProfileStatus.proposedRiskProfile;
                riskProfileData.originalRiskProfileLabel = jsLanguageLabel['txtProfile_' + riskProfileData.originalRiskProfile];
                riskProfileData.selectedAccountNumber = globalStore.selectedAccountNumber;
                if (globalStore.proposedRiskProfile) {
                    riskProfileData.proposedRiskProfile = globalStore.proposedRiskProfile;
                    riskProfileData.proposedRiskProfileToken = globalStore.proposedRiskProfileToken;
                    riskProfileData.proposedRiskProfileLabel = jsLanguageLabel['txtProfile_' + riskProfileData.proposedRiskProfile];
                }                
                getQuestionaireAssets(riskProfileData, step);
                wizard.validateStep(step);
            }

		}
		if (stepId === "retainportfolioprofile") {
			var rpfData = {};

            if(flowConfig.type === 'profile'){
                docObject = new nnip.classes.DutyOfCare();

                if (globalStore.multipleSelectedAccountNumber && globalStore.multipleSelectedAccountNumber.length > 1 ){
                    rpfData.originalRiskProfiles = globalStore.multipleSelectedProfiles;
                    rpfData.selectedAccountNumbers = globalStore.multipleSelectedAccountNumber;
                } else {
                    rpfData.selectedAccountNumber = globalStore.selectedAccountNumber;
                    rpfData.originalRiskProfile = globalStore.originalRiskProfile;
                    rpfData.originalRiskProfileLabel = jsLanguageLabel['txtInvestmentProfile_' + rpfData.originalRiskProfile];
                }
                wizard.validateStep(step);
                getRiskProfileRetainPortfolio(accountNumbers, rpfData, step);
            }else{
                rpfData.originalRiskProfile = globalStore.productSwitchContext.riskProfileStatus.activeRiskProfile;
                rpfData.proposedRiskProfile = globalStore.productSwitchContext.riskProfileStatus.proposedRiskProfile;
                rpfData.originalRiskProfileLabel = jsLanguageLabel['txtProfile_' + globalStore.productSwitchContext.riskProfileStatus.activeRiskProfile];  
                rpfData.selectedAccountNumber = globalStore.selectedAccountNumber;
                getRpfQuestionaireAssets(rpfData, step);
                wizard.validateStep(step);
            }

		}
		// Portfolio
		if (stepId === "portfolio") {
			var selectedAccount = globalStore.selectedAccountNumber;
			var selectedProductType = (globalStore.selectedProductType) ? globalStore.selectedProductType : globalStore.originalProductType;
			getInvestmentAccountProductCompostion(selectedAccount, selectedProductType);
			wizard.validateStep(step);
		}

		// Retain Portfolio
		if (stepId === "retainportfoliointro") {
			displayRetainPortfolioIntro();
			wizard.validateStep(step);
		}

		if (stepId === "retainportfolioprofile") {
			wizard.validateStep(step);
		}

		// Summary
		if (stepId === "summary") {
			displaySummary();
			wizard.validateStep(step);
		}

		// Confirmation
		if (stepId === "confirm") {
			confirmAction();
			$('#bottom_navigation').hide();
			wizard.validateStep(step);
		}

		// portfolio deviation
		if (stepId === "portfoliodeviation") {
			getProductCompostion(globalStore.selectedAccountNumber);
			wizard.validateStep(step);
		}

		// order proposal
		if (stepId === "orderproposal") {
			getOrderProposal(globalStore.selectedAccountNumber);
			wizard.validateStep(step);
		}		

		// order confirmation
		if (stepId === "confirmation") {
            $('#bottom_navigation').hide();
			wizard.validateStep(step);
		}				
	});

	// Previous button. If on step 1: go to the previous page. If not on step 1:
	// go back one step.
	$('.form-navigation #previous').on("click",function() {
		
		if (wizard.getActiveStep() === 1) {
			window.location.href = referrerPageUrl;
		}else if(wizard.getActiveStep() === 2){
            $('#confirmDataResetModal').modal('show').on('click', '#confirmDataoResetModalTarget', function (e) {
            		$('#confirmDataResetModal').modal('hide');
		            $('span[data-target="#step1"]').tab('show');
		        });          
		}else {
			var activeStep = wizard.getNextStep('rtl');
			$('span[data-target="#step' + activeStep + '"]').tab('show');
		}
	});

	// Next button goes forward if current block validates
	$('.form-navigation #next').on("click",function() {
        if(wizard.getActiveStepId() === "chooseaccount"){
            handleAccountSelectionByJspf();
		}
		
		var selectedProductType = $('input[name="producttype"]:checked').val(); 
		var checkIfAccountIsElegible = isSelectedAccountEligible(globalStore.selectedAccountNumber); 
		var skipDoorbeleggenForAccount = shouldSkipDoorbeleggenForAccount(globalStore.selectedAccountNumber);

		// add check if it should skip the next step..
        if(wizard.getActiveStepId() === "investmentmethod"){
			
            if(globalStore.originalInvestmentMethod ===  selectedProductType){
				if(checkIfAccountIsElegible) {
					wizard.skipSteps([4,5,6,7,8]); //if user has already selected LifeCycle product and selected Account is Eligible for retain portfolio
				} else {
					wizard.skipSteps([4,5,6]); //if user has already selected LifeCycle product and selected Account is NOT Eligible for retain portfolio
				}
					
            }else if(globalStore.selectedProductType !== 'EVS' && globalStore.selectedProductType !== 'EVD'){
				if(checkIfAccountIsElegible){
					wizard.skipSteps([5,6,7]); //if user later select LifeCycle product and selected Account is Eligible for retain portfolio
				} else {
					wizard.skipSteps([5]); //if user later select LifeCycle product and selected Account is NOT Eligible for retain portfolio
				}
            // Skip RP steps if selected account not eligible for RP but one of the users accounts is.    
            }else if(skipDoorbeleggenForAccount){
				wizard.skipSteps([5,6]);               
            }else{
                wizard.skipSteps([]); 
            }         
		}

		if (wizard.getActiveStepId() === "riskprofile") {
			if(skipDoorbeleggenForAccount){
				if(globalStore.selectedProductType !== 'EVS' && globalStore.selectedProductType !== 'EVD'){
					wizard.skipSteps([5,6,7]);  
				} else {
					wizard.skipSteps([5,6]);  
				}
			} else if(globalStore.selectedProductType !== 'EVS' && globalStore.selectedProductType !== 'EVD') {
				wizard.skipSteps([5]);             
			} else {
				wizard.skipSteps([]); 
			}
		}
		
				
		if(wizard.getActiveStepId() === "retainportfolioprofile"){
			if(globalStore.selectedProductType !== 'EVS' && globalStore.selectedProductType !== 'EVD') {
				wizard.skipSteps([7]);
			} else {
				wizard.skipSteps([]);
			}
		}

        var activeStep = wizard.getNextStep('ltr');

		var atTheEnd = activeStep >= wizard.getStepWizard().total;
		$('.form-navigation #next').toggle(!atTheEnd);
		$('.form-navigation #submit').toggle(atTheEnd);

		$('span[data-target="#step' + activeStep + '"]').trigger("click");

	});

	init_youtube_api();
}

var player;

var init_youtube_api = function() {
	/*
	 * Youtube api
	 */

	// 0. Only inserts the API when it's not already present.
	var ytLoaded = $('script[src="https://www.youtube.com/iframe_api"]').length;
	var watchedTimer;
	if (ytLoaded === 0) {

		// 1. This code loads the IFrame Player API code asynchronously.
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		// 2. Register player

		// 3. The API will call this function when the video player is ready.
		window['onPlayerReady'] = function(event) {}

		// 4. The API calls this function when the player's state changes.
		var done = false;
		window['onPlayerStateChange'] = function(event) {
			if (event.data === YT.PlayerState.PLAYING) {
				var videoId = player.getVideoData()['video_id'];
				watchedTimer = setTimeout(function() {
					var representation = docObject.getAssetObjectWithMovieId(videoId);
					docObject.markAsWatched(representation.id, "video");
				}, 0);
			} else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
				clearInterval(watchedTimer);
			}
		}

		window['stopVideo'] = function() {
			clearInterval(watchedTimer);
			player.stopVideo();
		}

	}
}

function isSelectedAccountEligible(selectedAccount){
	var result = globalStore.eligibleAccountsMapper.find(function(item){
		return item.accountId === selectedAccount
	});
	if (result.accountIsEligible) { return true}
	return false
}

// function that returns true if at least one of the accounts is eligible for Retail Portfolio
function isAnyAccountEligible(){
	var isAnyAccountEligible = _.some(globalStore.eligibleAccountsMapper, function(account) { return account.accountIsEligible;} );
	return isAnyAccountEligible;
}

// function that returns true if doorbeleggen should be skipped for the particular account. This is the case
// when the at least one of the accounts is eligible but the currently selected account is not eligible. 
function shouldSkipDoorbeleggenForAccount(selectedAccount) {	
	var shouldSkipDoorbeleggenForAccount = (isAnyAccountEligible() && !isSelectedAccountEligible(selectedAccount) );
	return shouldSkipDoorbeleggenForAccount;
}

function loadQuizModalIP(htmlBlockIdSelectorForResults) {
    //if (typeof (globalStore.questionaire) === 'undefined') {
        globalStore.questionaire = docObject.getDOCObject().assets.riskProfile.questionaire;
		quizIP = new nnip.classes.Quiz(globalStore.questionaire);
		globalStore.id_of_html_element_to_post_results_to = htmlBlockIdSelectorForResults
    //}
	$('#quizModal').modal({
		backdrop : 'static',
		keyboard : false
	});
}

function updateRiskProfile() {
    var quizModal = $('#quizModal');
	var activeProfile = quizModal.find('.well:visible');
	var activeProfileId = activeProfile.attr('id');
	var activeProfileLabel = activeProfile.find('.riskprofileTitle').html();
	var activeProfileImg = activeProfile.find('img').attr('src');
	globalStore.selectedRiskProfile = activeProfileId;
	globalStore.isUsingProposedRiskProfile = false;
	showInvestmentProfileResult(activeProfileImg, activeProfileLabel, globalStore.id_of_html_element_to_post_results_to);
    quizModal.modal('hide');
}

function loadAssetModal(title, assetObject) {

	wizard.updateAssetsModalButtons(assetObject.id);
	var isCompleted = $('#' + assetObject.id).data('completed');
    var docModal = $("#docModal");
    var nextAssetButton = $('#nextAssetButton');

	docModal.find('#docModalLabel').html(title);
	docModal.data('type', assetObject.type);

	if (assetObject.type === 'YOUTUBEVIDEO') {
		var YoutubeHolderAndGdprNotification = '<div id="youtubePlayer"></div>' + '<div class="youtube_gdpr_notification"><span class="i">i</span>' + jsLanguageLabel.gdpr_doc_video_youtube_popup_notice + '</div>'; 
		if (isCompleted) {
            nextAssetButton.prop('disabled', false);

		} else {
            nextAssetButton.attr('disabled', 'disabled');
		}
		docModal.find('.modal-body').html(YoutubeHolderAndGdprNotification); 
		loadVideo(assetObject.movieId);
	} else {
		docModal.find('.modal-body').html(assetObject.text);
        nextAssetButton.prop('disabled', false);
		docObject.markAsWatched(assetObject.id, "text");
	}
	docModal.modal('show');
}

function viewAsset(id, title, rank) {
	var assetObject = docObject.getAssetObjectWithId(parseInt(id));
	/* function in modal jsp */
	loadAssetModal(title, assetObject, rank);
}


function initOverlay(){
    var fundDetailObj = {
        pagelink : "",
        linkId : "",
        offsetTop : ""
    };
    $('a.openOverlay').on('click', function(event){
        event.preventDefault();
        fundDetailObj.pagelink = this.getAttribute('data-href');
        fundDetailObj.linkId = this.getAttribute('id');
        fundDetailObj.offsetTop = ($("#" + fundDetailObj.linkId).offset().top) - 10;
        $(window).scrollTop(0);
        toggleOverlay(fundDetailObj, 'open');
        return false;
    });

    $('button.overlay-close').on('click', function(event){
        event.preventDefault();
        toggleOverlay(fundDetailObj, 'close');    
        return false;
    });
}

function toggleOverlay(fundDetailObj, state) {
    var overLay = $('.overlay');
    if(state === 'open'){
        overLay.height($(document).height());
        $('#openfunddetailoverlay').attr('src', fundDetailObj.pagelink);
        overLay.removeClass('close').addClass('open');
        $('.page').addClass('overlay-open');
    }else if(state === 'close'){
        $('#openfunddetailoverlay').attr('src', "");
        overLay.removeClass('open').addClass('close');
        $('.page').removeClass('overlay-open');    
        overLay.height(0);
    } 
}

function getProductSwitchContextForAccount(accountNumber, step) {
	$.getJSON('/web/nniprestserviceservlet/productSwitchContext?accountId=' + accountNumber, function(productSwitchContext) {
		/* Init duty of care object */
		docObject = new nnip.classes.DutyOfCare(productSwitchContext);
		docObject.getDOCObject().assets.languagelabels = jsLanguageLabel;

		/*
		 * Add translated labels in docobject for proper rendering in mustache
		 * templates
		 */
		_.each(docObject.getDOCObject().assets.dutyOfCareAssetsForProductSwitch, function(asset, index) {
			asset.txtLabel = jsLanguageLabel[asset.name];
		});

		globalStore.productSwitchContext = productSwitchContext;

		var currentProduct = _.find(productSwitchContext.productUniverse, function(product) {
			return product.isCurrentProduct;
		});
		globalStore.originalInvestmentMethod = currentProduct.investmentMethod;
		globalStore.originalInvestmentMethodDescription = currentProduct.investmentMethodLabel;
		globalStore.originalRiskProfile = productSwitchContext.riskProfileStatus.activeRiskProfile;

		if (productSwitchContext.riskProfileStatus.proposedRiskProfile && productSwitchContext.riskProfileStatus.proposedRiskProfileToken) {
			globalStore.proposedRiskProfile = productSwitchContext.riskProfileStatus.proposedRiskProfile;
			globalStore.proposedRiskProfileToken = productSwitchContext.riskProfileStatus.proposedRiskProfileToken;
		}

		wizard.setTemplate('#introductionAssets', globalStore[docButtonTemplate], docObject.getDOCObject().assets, globalStore[docAssetPartial]);
	}).fail(function(errMsg) {
		setError(errMsg.status, errMsg.responseText);
	}).always(function() {
		wizard.validateStep(step);
	});
};

function useProposedRiskProfile(activeProfileImg, activeProfileLabel, htmlBlockIdSelector) {
	globalStore.selectedRiskProfile = globalStore.proposedRiskProfile;
	globalStore.isUsingProposedRiskProfile = true;
	var blockSelector = globalStore.id_of_html_element_to_post_results_to ? globalStore.id_of_html_element_to_post_results_to : htmlBlockIdSelector;
	showInvestmentProfileResult(activeProfileImg, activeProfileLabel, blockSelector);
}

function showInvestmentProfileResult(activeProfileImg, activeProfileLabel, htmlBlockIdSelector) {

    var investmentProfileResult = htmlBlockIdSelector ? $(htmlBlockIdSelector) : console.error('You did not provide a html block selector for showInvestmentProfileResult()');
    investmentProfileResult.find('img').attr('src', activeProfileImg);
    investmentProfileResult.find('.riskprofileTitle').html(activeProfileLabel);
    investmentProfileResult.show();
	$('#proposedRiskProfile').hide();

	var currentStep = wizard.getActiveStep();
	wizard.validateStep(currentStep);
}

function setError(errorCode, errorMessage) {
	globalStore.isErrorOccured = true;
	$('.ajaxloader').hide();
	var element = $(".tab-pane").filter(":visible").find(".errormessage");
	element.removeClass("hidden");
	element.html(errorMessage);
}

function clearError() {
	globalStore.isErrorOccured = false;
	$(".tab-pane").filter(":visible").find(".errormessage").empty();
}

function getRiskProfile(accounts, riskProfileData, step) {
    if(typeof(accounts) !== "undefined" && typeof(globalStore.selectedRiskProfile) === "undefined"){    
        riskProfileData.isMultiple = (accounts.length > 1);
        getQuestionaireAssets(riskProfileData, step);           
    }
}

function getQuestionaireAssets(riskProfileData, step) {
	if (typeof (docObject.getDOCObject().assets.riskProfile) === 'undefined') {
		$.getJSON('/web/nniprestserviceservlet/riskProfile', function(questionaire) {
			docObject.setQuestionaireAssets(questionaire);

			riskProfileData.assets = questionaire.assets;
			riskProfileData.languagelabels = jsLanguageLabel;

			/*
			 * Add translated labels in docobject for proper rendering in
			 * mustache templates
			 */
			_.each(riskProfileData.assets, function(asset, index) {
				asset.txtLabel = jsLanguageLabel[asset.name];
				asset.rank = index;
			});
			wizard.setTemplate('#investmentProfile', globalStore[docInvestmentProfileTemplate], riskProfileData, globalStore[docAssetPartial]);
		}).fail(function(errMsg) {
			setError(errMsg.status, errMsg.responseText);
		}).always(function() {
			wizard.validateStep(step);
		});
	}
}

// This function creates an <iframe> (and YouTube player) after the API code
// downloads.
function loadVideo(videoId) {
	player = new YT.Player('youtubePlayer', {
		videoId : videoId,
		height : '300px',
		width : '100%',
		host: 'http://www.youtube-nocookie.com',
        playerVars: {rel: 0},
		events : {
			'onReady' : onPlayerReady,
			'onStateChange' : onPlayerStateChange
		}
	});
}

nnip.classes.DutyOfCare = function(userAssets) {

	"use strict";

	/* Variables */
	var myAssets = userAssets;

	var DocAssets = function() {
        if(typeof(myAssets) !== 'undefined'){

        	if(typeof(myAssets.dutyOfCareAssetsForProductSwitch) !== 'undefined'){
	            _.each(myAssets.dutyOfCareAssetsForProductSwitch, function(asset, index) {
	                asset.rank = index;
	            });
          	}

          	if(typeof(myAssets.dutyOfCareAssetsReadingRoom) !== 'undefined'){
	            _.each(myAssets.dutyOfCareAssetsReadingRoom, function(asset, index) {
	                asset.rank = index;
	            });
          	}

        }

		return myAssets;
	};

	var DOCObject = function() {
		this.assets = new DocAssets();
	};

	/* Public */

	// returns StepWizard object
	this.getDOCObject = function() {
		return DutyOfCareObject;
	};

	this.getAssetObjectWithId = function(assetId) {

		var dutyOfCareAssetsForProduct = getAllDOCAssets(DutyOfCareObject.assets);
		dutyOfCareAssetsForProduct = _(dutyOfCareAssetsForProduct).chain().pluck('representations').flatten().findWhere({
			id : assetId
		}).value();

		if (typeof dutyOfCareAssetsForProduct !== 'undefined') {
			return dutyOfCareAssetsForProduct;
		} else {
			return '';
		}

	};

	this.getAssetObjectWithMovieId = function(movieId) {
		var dutyOfCareAssetsForProduct = getAllDOCAssets(DutyOfCareObject.assets);
		dutyOfCareAssetsForProduct = _(dutyOfCareAssetsForProduct).chain().pluck('representations').flatten().findWhere({
			movieId : String(movieId)
		}).value();

		if (typeof dutyOfCareAssetsForProduct !== 'undefined') {
			return dutyOfCareAssetsForProduct;
		} else {
			return '';
		};

	};

	this.getRepresentationsWithId = function(id) {

		var dutyOfCareAssetsForProduct = getAllDOCAssets(DutyOfCareObject.assets);
		dutyOfCareAssetsForProduct = _(dutyOfCareAssetsForProduct).findWhere({
			rank : id
		});

		if (typeof dutyOfCareAssetsForProduct !== 'undefined') {
			return dutyOfCareAssetsForProduct['representations'];
		} else {
			return '';
		};
	};

	this.markAsWatched = function(representationId, type) {
		var representationId = representationId;
		var url = '/web/nniprestserviceservlet/dutyOfCare/representation/' + representationId + '/markAsViewed';
		var data = null;
		$.ajax({
			type : "POST",
			url : url,
			data : data,
			contentType : "application/json;",
			dataType : "json",
			success : function(data) {

				var represId = $('#' + representationId);
                if(type === "video"){
					represId.parents('.row-fluid')
						.find('.rRoomButton--asset--video i.asset-icon-unseen')
						.removeClass('asset-icon-unseen')
						.addClass('asset-icon-seen');

						represId.parents('.row-fluid').find('.rRoomButton--asset--video').removeClass('unseen');
                } else {
					represId.parents('.row-fluid').find('.rRoomButton--asset--text').removeClass('unseen');
				}
                represId.parents('.row-fluid').find('.rRoomButton').data('completed', true);
                represId.closest('.row-fluid').next().find('rRoomButton[disabled]').prop('disabled',false);
				$('#nextAssetButton').prop('disabled',false);
				var currentStep = wizard.getActiveStep();
				wizard.validateStep(currentStep);
			},
			error : function(errMsg) {
				setError(errMsg.status, errMsg.responseText);
				var currentStep = wizard.getActiveStep();
				wizard.validateStep(currentStep);
			}
		});
			
	};

	this.setQuestionaireAssets = function(questionaireAssets) {
		DutyOfCareObject.assets.riskProfile = questionaireAssets;
        DutyOfCareObject.assets.questionnaireEndpoint = 'dutyOfCare/riskProfile';

	};

	this.setRpfQuestionaireAssets = function(questionaireAssets) {
		DutyOfCareObject.assets.retainportfolioProfile = questionaireAssets;
		DutyOfCareObject.assets.questionnaireEndpoint = 'dutyOfCare/retainPortfolioRiskProfile';
	};

	this.calculateRiskProfile = function(quiz, answers) {
		var url = '/web/nniprestserviceservlet/'+ DutyOfCareObject.assets.questionnaireEndpoint +"?accountId=" + answers.accounts;
		$.ajax({
			type : "POST",
			url : url,
			// The key needs to match your method's input parameter
			// (case-sensitive).
			data : JSON.stringify(answers),
			contentType : "application/json;",
			dataType : "json",
			success: function(data) {
				quiz.displayResult(data);
			},
			error : function(errMsg) {
				setError(errMsg.status, errMsg.responseText);
				var currentStep = wizard.getActiveStep();
				wizard.validateStep(currentStep);
			}
		});

	};

	this.originalInvestmentMethod = function() {
		var productUniverse = DutyOfCareObject.assets.productUniverse;
		var currentProduct = _.find(productUniverse, function(product) {
			return product.isCurrentProduct;
		});

		return currentProduct ? currentProduct.investmentMethod : null;
	};

	function getAllDOCAssets(context) {
		var allAssets = "";

		if(typeof(context.dutyOfCareAssetsForProductSwitch) !== 'undefined'){
            allAssets = context.dutyOfCareAssetsForProductSwitch;
	       	_.each(context.productUniverse, function(entry, index) {
				allAssets = _.union(allAssets, entry.dutyOfCareAssetsForProduct);
			});
      	}
        
        if(typeof(context.riskProfile) !== 'undefined'){
            _.each(context.riskProfile, function(entry, index) {
				allAssets = _.union(allAssets, entry);
			});	
        }

        if(typeof(context.retainportfolioProfile) !== 'undefined'){
            _.each(context.retainportfolioProfile, function(entry, index) {
                allAssets = _.union(allAssets, entry);
            });
        }

      	if(typeof(context.dutyOfCareAssetsReadingRoom) !== 'undefined'){
            allAssets = context.dutyOfCareAssetsReadingRoom;
      	}

		return allAssets;
	}

	// load or create new Duty of Care object
	var DutyOfCareObject = new DOCObject();

};